<template>
  <footer id="colophon">
    <b-container>
      <b-row>
        <b-col
          cols="12"
          class="d-flex justify-content-between flex-column mb-md-0 text-center text-md-left"
        >
          <p class="small text-muted d-none d-md-block">
            <span> &copy; {{ year }} Drill Maps, Inc. </span>
            <span style="margin-left:30px;">
              <router-link :to="'/terms'"> Term &amp; Condition</router-link>
            </span>
            <span style="margin-left:30px;">
              <router-link :to="'/privacy'"> Privacy Policy</router-link>
            </span>
          </p>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
export default {
  data: () => {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>

<style lang="scss" scoped>
#colophon {
  padding: 1rem 0;
  .logo {
    height: 27px;
    margin-bottom: 1rem;
  }
  .smaller {
    font-size: 90%;
    color: #888;
    & > *:not(:last-child) {
      margin-bottom: 0.3rem;
    }
    svg {
      margin-right: 0.5rem;
    }
  }
  .text-muted {
    opacity: 0.75;
  }
  address {
    margin: 0;
  }
  h4 {
    font-size: 100%;
    font-weight: bold;
    margin-bottom: 1rem;
  }
  a {
    color: inherit;
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    &.inline li {
      display: inline-block;
    }
    a {
      display: inline-block;
      margin-bottom: 0.5rem;
    }
  }
  .social-icon {
    font-size: 1.5rem;
    a {
      margin-right: 0.9rem;
    }
    .fa-facebook {
      color: #3b5998;
    }
    .fa-twitter {
      color: #00aced;
    }
    .fa-youtube {
      color: #d00;
    }
    .fa-instagram {
      color: #c32aa3;
    }
  }
}
@media (max-width: 750px) {
  #colophon {
    padding: 3rem 0;
  }
}
</style>
